import { EventsName } from '@space-lib-events/constants'

export type LoginEventOptions = { signInRedirect?: boolean }

export type LoginEvent = { detail?: LoginEventOptions }

const loginEventDispatch = (options?: LoginEventOptions) => {
  window.dispatchEvent(new CustomEvent<LoginEventOptions>(EventsName.LOGIN, { detail: options }))
}

const loginEventListener = (listener: (event: LoginEvent) => void) => {
  window.addEventListener(EventsName.LOGIN, listener as EventListener)

  return () => {
    window.removeEventListener(EventsName.LOGIN, listener as EventListener)
  }
}

export { loginEventDispatch, loginEventListener }
